import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from "@angular/core";
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { getAuth, provideAuth } from "@angular/fire/auth";
import { provideRouter } from "@angular/router";
import { environment } from "@environments/environment";
import * as Sentry from "@sentry/angular";
import { SquidexClient } from "@squidex/squidex";

import { SQUIDEX_CLIENT } from "../squidex/client";

import { routes } from "./app.routes";

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    {
      provide: SQUIDEX_CLIENT,
      useFactory: () => {
        return new SquidexClient(environment.squidex);
      },
    },
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
  ],
};
